export type AudioLevelState = {
    audioLevel: number;
};

export type OnAudioLevelStateChangeHandler = (state: AudioLevelState) => void;

export const createAudioLevelMonitor = (audioContext: AudioContext,
                                        audioStream: MediaStream,
                                        onAudioLevelStateChangeHandler: OnAudioLevelStateChangeHandler) => {

    console.log('[AudioLevel] Creating new Audio Level Monitor for stream -> ', audioStream);
    const detectionFrequencyInMs = 250,
        audioLevelThreshold = 150

    const analyser = audioContext.createAnalyser();
    analyser.fftSize = 128;

    const source = audioContext.createMediaStreamSource(audioStream);
    source.connect(analyser);

    const intervalId = setInterval(() => {
        const data = new Uint8Array(analyser.frequencyBinCount);
        analyser.getByteFrequencyData(data);

        //const isSoundDetected = data.some((value) => value >= audioLevelThreshold);
        const averagedDataValue = data.reduce((pv, cv) => pv + cv, 0) / data.length;

        const percentage =
            averagedDataValue > audioLevelThreshold
                ? 100
                : Math.round((averagedDataValue / audioLevelThreshold) * 100);

        if (audioStream.getAudioTracks()[0]?.enabled) {
            onAudioLevelStateChangeHandler({audioLevel: percentage});
        } else {
            onAudioLevelStateChangeHandler({audioLevel: 0});
        }
    }, detectionFrequencyInMs);

    return async function stop() {
        console.log('[AudioLevel] Stopping Audio Level Monitor for stream -> ', audioStream);
        clearInterval(intervalId);

        // clean-up the AudioContext elements
        source.disconnect();
        analyser.disconnect();
        await audioContext.close().catch((e) => console.error('[AudioLevel] Error stopping Audio Level Monitor -> ',e));

        // stop the stream
        audioStream.getTracks().forEach((track) => {
            track.stop();
            audioStream.removeTrack(track);
        });
    };
};
